/**
 * @generated SignedSource<<aba5f49524ea73d30dca3adc59bf3d87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineOccasionStatusTabScreenQuery$variables = {
  routineId: string;
  sequenceNumber: number;
  workspaceId: string;
};
export type WorkspaceRoutineOccasionStatusTabScreenQuery$data = {
  readonly routine: {
    readonly id: string;
    readonly isArchived: boolean;
    readonly isWorkspaceOwner: boolean;
    readonly title: string;
    readonly workspaceOccasion: {
      readonly id: string;
      readonly sequenceNumber: number;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion">;
    } | null;
  } | null;
};
export type WorkspaceRoutineOccasionStatusTabScreenQuery = {
  response: WorkspaceRoutineOccasionStatusTabScreenQuery$data;
  variables: WorkspaceRoutineOccasionStatusTabScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sequenceNumber"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v6 = {
  "alias": null,
  "args": [
    (v5/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "isWorkspaceOwner",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "sequenceNumber",
    "variableName": "sequenceNumber"
  },
  (v5/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "registeredIssueCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceRoutineOccasionStatusTabScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "RoutineWorkspaceOccasion",
            "kind": "LinkedField",
            "name": "workspaceOccasion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v8/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceRoutineOccasionStatusTabScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "RoutineWorkspaceOccasion",
            "kind": "LinkedField",
            "name": "workspaceOccasion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "storesCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "storesCompletedCount",
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "descriptionImages",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "height",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "width",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "urlExpiresAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbhash",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "descriptionFiles",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isOrg",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalTaskExecutionCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineWorkspaceOccasionEdge",
                "kind": "LinkedField",
                "name": "occasions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timezone",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineOccasion",
                    "kind": "LinkedField",
                    "name": "occasion",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "routine",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "occasionStatus",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "calculateNoTasks",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "calculateNotCompletedStarted",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expireAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deadlineAt",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "373d2c38d1a017a3a9f849ca9b6b8efa",
    "id": null,
    "metadata": {},
    "name": "WorkspaceRoutineOccasionStatusTabScreenQuery",
    "operationKind": "query",
    "text": "query WorkspaceRoutineOccasionStatusTabScreenQuery(\n  $routineId: ID!\n  $sequenceNumber: Int!\n  $workspaceId: ID!\n) {\n  routine(id: $routineId) {\n    id\n    title\n    isArchived\n    isWorkspaceOwner(workspaceId: $workspaceId)\n    workspaceOccasion(sequenceNumber: $sequenceNumber, workspaceId: $workspaceId) {\n      id\n      sequenceNumber\n      ...WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion\n    }\n  }\n}\n\nfragment DescriptionContentFiles_files on File {\n  id\n  url\n  ...FileCollectionItem_File\n}\n\nfragment DescriptionContentMedia_Media on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  __typename\n}\n\nfragment FileCollectionItem_File on File {\n  name\n  id\n  url\n  type\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment RoutineOccasionDescriptionContent_Routine on Routine {\n  descriptionImages {\n    ...DescriptionContentMedia_Media\n    id\n  }\n  description\n  descriptionFiles {\n    ...DescriptionContentFiles_files\n    id\n  }\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment WorkspaceRoutineOccasionDescription_routine on Routine {\n  description\n  descriptionImages {\n    __typename\n    id\n  }\n  descriptionFiles {\n    id\n  }\n  ...RoutineOccasionDescriptionContent_Routine\n}\n\nfragment WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion on RoutineWorkspaceOccasion {\n  id\n  storesCount\n  storesCompletedCount\n  issueCount\n  registeredIssueCount\n  ...WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion\n}\n\nfragment WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion on RoutineWorkspaceOccasion {\n  startAt\n  storesCompletedCount\n  storesCount\n}\n\nfragment WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion on RoutineWorkspaceOccasionEdge {\n  store {\n    id\n    name\n    timezone\n  }\n  occasion {\n    ...RoutineOccasionStatusCircle_RoutineOccasion\n    registeredIssueCount\n    sequenceNumber\n    issueCount\n    id\n  }\n}\n\nfragment WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion on RoutineWorkspaceOccasion {\n  ...WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion\n  routine {\n    id\n    ...WorkspaceRoutineOccasionDescription_routine\n  }\n  totalTaskExecutionCount\n  occasions {\n    store {\n      id\n      name\n    }\n    occasion {\n      id\n      routine {\n        id\n      }\n      occasionStatus: status\n      issueCount\n      registeredIssueCount\n    }\n    ...WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion\n  }\n}\n"
  }
};
})();

(node as any).hash = "e486e323304a50cc540182951f678a0b";

export default node;
